module.exports = __webpack_public_path__ + "img/Myrmidon_Bracer.5d38207a.png";